import React, { useContext, useEffect, useState } from "react";
import "../components/points/Points.scss";
import { Box, Typography, Button } from "@mui/material";
import PriceCard from "../components/points/Voucher";
import Pnts from "../components/points/Pnts";
import { getResults } from "../utils/apis";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Bowser from "bowser";
import { KEY_BILLINGCITY } from "../utils/contants";
import { translation_en } from "../translations/translation_en";
import { translation_hi } from "../translations/translation_hi";

interface voucherProps {
  BtnReq?: boolean;
}


const Voucher: React.FC<voucherProps> = () => {

  function translate(obj: any, path: string) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

// ✅ Choose translation based on saved language
const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = lang.startsWith("hi") ? translation_hi : translation_en;

// ✅ Define t() function that mimics react-i18next’s syntax
const t = (key: string) => translate(translations, key);

  const [BtnReq, setBtnReq] = useState<boolean>(false);
  const [pointsData, setPointsData] = useState<any>(null);
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const decryptedId = id ? atob(id) : "";
  const billing_city = localStorage.getItem(KEY_BILLINGCITY) || null;

  // ---------------- Browser & Device Info ----------------
  const getBrowserDetails = (userAgent: string) => {
    const parsed = Bowser.parse(userAgent);
    let browserName = parsed.browser?.name || "unknown";
    let browserVersion = parsed.browser?.version || "unknown";

    if (browserName === "unknown" || browserVersion === "unknown") {
      const chromeMatch = userAgent.match(/Chrome\/([0-9.]+)/);
      const firefoxMatch = userAgent.match(/Firefox\/([0-9.]+)/);
      const safariMatch = userAgent.match(/Version\/([0-9.]+) Safari/);
      const edgeMatch = userAgent.match(/Edg\/([0-9.]+)/);

      if (chromeMatch) {
        browserName = "Chrome";
        browserVersion = chromeMatch[1];
      } else if (firefoxMatch) {
        browserName = "Firefox";
        browserVersion = firefoxMatch[1];
      } else if (safariMatch) {
        browserName = "Safari";
        browserVersion = safariMatch[1];
      } else if (edgeMatch) {
        browserName = "Edge";
        browserVersion = edgeMatch[1];
      }
    }

    const device_os_name = parsed.os?.name || "unknown";
    const device_os_version = parsed.os?.version || "unknown";

    return { browserName, browserVersion, device_os_name, device_os_version };
  };

  useEffect(() => {
    const fetchData = async () => {
      if (authContext) {
        const { token }: any = authContext;

        // Get stored location if available
        const latitude = localStorage.getItem("latitude") || undefined;
        const longitude = localStorage.getItem("longitude") || undefined;
          const tokenn = localStorage.getItem("token");

        const userAgent = navigator.userAgent;
        const { browserName, browserVersion, device_os_name, device_os_version } = getBrowserDetails(userAgent);

        const notificationConsent = localStorage.getItem("notification_consent_status") || "0";
        const locationConsent = localStorage.getItem("location_consent_status") || "0";
        const pageName = localStorage.getItem("page_name") || "";

        try {
          const data = await getResults(
            decryptedId,
           String(tokenn),
            userAgent,
            latitude,
            longitude,
            device_os_version,
            browserName,
            browserVersion,
            notificationConsent,
            locationConsent,
            pageName
          );

          setPointsData(data);
          setBtnReq(data.result_details?.req_approval || false);
        } catch (error) {
          console.error("Failed to fetch data:", error);
        }
      }
    };

    fetchData();
  }, [authContext, decryptedId]);

  return (
    <Box sx={{ width: "100%" }}>
      <Pnts pointsData={pointsData} />

      <Box className="vouchers"></Box>

      <Box
        sx={{
          background: "linear-gradient(141deg, #282829 -0.06%, #620B17 97.43%)",
          textAlign: "start",
          padding: "32px 20px",
          marginBottom: "80px",
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "24px",
            letterSpacing: "-0.32px",
            color: "#FFF",
            maxWidth: "272px",
          }}
        >
          {t("rewards.title")}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20px",
            color: "#C5C6C7",
            maxWidth: "272px",
            marginBottom: "20px",
          }}
        >
          {t("rewards.sub_title")}
        </Typography>
        <Button
          sx={{
            marginTop: "20px",
            background: "#C8172F",
            width: "100%",
            borderRadius: "8px",
            color: "#FFF",
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: 500,
            textTransform: "none",
            ":hover": { color: "#fff" },
          }}
          onClick={() => navigate("#")}
        >
          {t("rewards.view_all_reward")}
        </Button>
      </Box>

      <Box className="foot" sx={{ display: "flex", width: "100%" }}>
        {BtnReq && (
          <Button
            className="btn_trans"
            onClick={() =>
              window.parent.postMessage({ action: "redirectTo", label: "pmi-all-tasks" }, "*")
            }
          >
            {t("taskdetaitls.availability.result.check_status")}
          </Button>
        )}
        <Button
          className="btn_red"
          onClick={() =>
            window.parent.postMessage({ action: "redirectTo", label: "pmi-home-page" }, "*")
          }
        >
          {t("taskdetaitls.educational.result.go_to_home")}
        </Button>
      </Box>
    </Box>
  );
};

export default Voucher;